module.exports = __webpack_public_path__ + "static/media/check-green.232b386c.svg";